/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cx from 'classnames';
import s from './blindReturn.module.css';
import SvgIcon from '../SvgIcon';
import { ngA11ySelection } from '../../lib/a11yUtils';

export const mapStateToProps = ({ language }) => ({
  addBlindReturnHeader: language['returns.step_1.add_blind_return_header'],
  addBlindReturnLinkText: language['returns.step_1.add_blind_return_link_text'],
});

const BlindReturn = ({
  addBlindReturnHeader,
  addBlindReturnLinkText,
  clickCallback = () => {},
}) => {
  const handleSelection = (e) => {
    if (ngA11ySelection(e)) {
      clickCallback();
    }
  };
  return (
    <div
      className={cx('return-item-container', s.blind_return_container, 'blind_return_container')}
      onClick={handleSelection}
      onKeyDown={handleSelection}
      role="button"
      tabIndex="0"
    >
      <div className="add_icon_container">
        <SvgIcon name="addIcon" />
      </div>
      <div className={cx(s.blind_return_copy_container, 'blind_return_copy_container')}>
        <p className={cx('blind-return-description', s.blind_return_copy)}>
          {addBlindReturnHeader}
        </p>
      </div>
      <div className={cx(s.blind_return_link_container, 'blind_return_link_container')}>
        <a className="blind-return-add-link">{addBlindReturnLinkText}</a>
      </div>
    </div>
  );
};

BlindReturn.defaultProps = {
  clickCallback: () => {},
};

BlindReturn.propTypes = {
  addBlindReturnHeader: PropTypes.string.isRequired,
  addBlindReturnLinkText: PropTypes.string.isRequired,
  clickCallback: PropTypes.func,
};

export default connect(mapStateToProps)(BlindReturn);
